import styled from "../../../../config/emotion";

export const ErrorMessage = styled.span`
  font-size: 12px;
  color: red;
  font-weight: italic;
`;

export const ChangePasswordForm = styled.form`
  display: flex;
  flex-direction: column;
`;
